import { ActionView } from '../../api/types'
import { Routes } from '../../navigation/Routes'

export const buildActionReferentiel = (id: number, titre: string, image?: string | null): ActionView => ({
  type: 'view',
  viewName: Routes.Referentiel,
  params: { id, titre, image },
})
